
import { dm_coso } from "../../models/response/category/dm_coso";
import { dm_he } from "../../models/response/category/dm_he";
import { dm_khoi } from "../../models/response/category/dm_khoi";
import { dm_namhoc } from "../../models/response/category/dm_namhoc";
import { dm_truong } from "../../models/response/category/dm_truong";
import { dm_truong_khoi_he } from "../../models/response/category/dm_truong_khoi_he";
import {
    eCategorySourceActionTypeIds, ICoSoLoadStart, ICoSoLoadSuccess, IHeLoadStart, IHeLoadSuccess,
    IKhoiLoadStart, IKhoiLoadSuccess, INamHocLoadStart,
    INamHocLoadSuccess, ITruongKhoiHeLoadStart, ITruongKhoiHeLoadSuccess, ITruongLoadStart, ITruongLoadSuccess
} from "../action-types/ICategorySourceActionTypes";

export const categorySourceActions = {

    loadDmTruongStart: (): ITruongLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_TRUONG_LOAD_START
        }
    },
    loadDmTruongSuccess: (payload: dm_truong[]): ITruongLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_TRUONG_LOAD_SUCCESS,
            payload: payload
        }
    },
    loadDmCoSoStart: (): ICoSoLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_COSO_LOAD_START
        }
    },
    loadDmCoSoSuccess: (payload: dm_coso[]): ICoSoLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_COSO_LOAD_SUCCESS,
            payload: payload
        }
    },
    loadHeStart: (): IHeLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_HE_LOAD_START
        }
    },
    loadHeSuccess: (payload: dm_he[]): IHeLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_HE_LOAD_SUCCESS,
            payload: payload
        }
    },
    loadKhoiStart: (): IKhoiLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_KHOI_LOAD_START
        }
    },
    loadKhoiSUCCESS: (payload: dm_khoi[]): IKhoiLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_KHOI_LOAD_SUCCESS,
            payload: payload
        }
    },

    loadNamHocStart: (): INamHocLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_NAMHOC_LOAD_START
        }
    },
    loadNamHocSuccess: (payload: dm_namhoc[]): INamHocLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_NAMHOC_LOAD_SUCCESS,
            payload: payload
        }
    },

    loadDmTruongKhoiHeStart: (): ITruongKhoiHeLoadStart => {
        return {
            type: eCategorySourceActionTypeIds.DM_TRUONG_KHOI_HE_LOAD_START
        }
    },
    loadDmTruongKhoiHeSuccess: (payload: dm_truong_khoi_he[]): ITruongKhoiHeLoadSuccess => {
        return {
            type: eCategorySourceActionTypeIds.DM_TRUONG_KHOI_HE_LOAD_SUCCESS,
            payload: payload
        }
    }


}
